import React from 'react'
import Moment from 'moment-timezone'
import {Button} from '@material-ui/core'
import AddIcon from '@material-ui/icons/AddToPhotos'

import ValueFormatter from '../components/value-formatter'

import Config from '../config'

const numberSort = (num1,num2) => {
  return num1 - num2
}

const getGridConfig = (actionClickHandler,openNewPurchaseForm) => {

  let userData = Config.getConfig('userData')
  
  let gridconfig = {
   
    visibleRowBufferSize : 10,
  
    columnDefs : [
      {
        field: "purchase_date",
        headerName: "Purchase Date",
        menuTabs : [],
        filter: 'agDateColumnFilter',
        filterParams : {
          filterOptions : ['greaterThan','inRange'],
          suppressAndOrCondition : true,
          inRangeInclusive : true,
          comparator : function (filter, value) {
            let filterMoment = Moment(filter)
            let valueMoment = Moment(value).tz('Europe/London')
  
            if (valueMoment.isSame(filterMoment,'day')) return 0
            if (valueMoment.isBefore(filterMoment,'day')) return -1
            if (valueMoment.isAfter(filterMoment,'day')) return 1
          },
        },
        valueFormatter : item => ValueFormatter.formatDate(item.value),
        width : 140,
        sortable: true,
      },
      {
        field: "group_name",
        headerName: "Purchase group",
        menuTabs : [],
        width : 200,
        sortable: true,
        filter: true,
      },
      {
        field: "type_name",
        headerName: "Purchase type",
        menuTabs : [],
        width : 200,
        sortable: true,
        filter: true,
      },
      {
        field: "detail",
        headerName: "Detail",
        menuTabs : [],
        width : 200,
        sortable: true,
        filter: true,
      },
      {
        field: "amount",
        headerName: "Gross amount",
        menuTabs : [],
        filter: true,
        sortable: true,
        headerClass : "rightAlignHeader",
        cellClass : 'numberGridCell',
        valueFormatter : item => ValueFormatter.formatMoneyOrNull(item.value),
        comparator: numberSort,
        width : 140,
      },
      {
        field: "vat",
        headerName: "VAT",
        menuTabs : [],
        filter: true,
        sortable: true,
        headerClass : "rightAlignHeader",
        cellClass : 'numberGridCell',
        valueFormatter : item => ValueFormatter.formatMoneyOrNull(item.value),
        comparator: numberSort,
        width : 140,
      },
      {
        field: "bankAccountName",
        headerName: "Account Name",
        menuTabs : [],
        width : 140,
        sortable: true,
      },
      {
        field: "transaction_date",
        headerName: "Transaction",
        menuTabs : [],
        filter: 'agDateColumnFilter',
        filterParams : {
          filterOptions : ['greaterThan','inRange'],
          suppressAndOrCondition : true,
          inRangeInclusive : true,
          comparator : function (filter, value) {
            let filterMoment = Moment(filter)
            let valueMoment = Moment(value).tz('Europe/London')
  
            if (valueMoment.isSame(filterMoment,'day')) return 0
            if (valueMoment.isBefore(filterMoment,'day')) return -1
            if (valueMoment.isAfter(filterMoment,'day')) return 1
          },
        },
        valueFormatter : item => ValueFormatter.formatDate(item.value),
        width : 140,
        sortable: true,
      },
      {
        field: "scan_image",
        headerName: "[Create statement]",
        menuTabs : [],
        filter: false,
        sortable: false,
        cellRenderer: 'actionCellRenderer',
        cellRendererParams: item =>
          { return {
            clicked: actionClickHandler,
            view : true,
            print : true,
            download : true,
            printAndDownloadDisabled : !item.data.scan_image || item.data.scan_image.length === 0,
            scan_image : item.data.scan_image,
            link : item.data.transaction_id || item.data.expense_id,
        }},
        headerComponent: (props) => {
          return userData.edit_right ? 
           (<Button onClick={openNewPurchaseForm} color="primary" startIcon={<AddIcon />}>new purchase</Button>) 
           :
           (
           <div class="ag-cell-label-container">
            <div class="ag-header-cell-label">
                <span class="ag-header-cell-text">Action</span>
            </div>
          </div>)
        },
      },
    ]
  }

  return gridconfig
}

export default getGridConfig
